import { render, staticRenderFns } from "./ActivityCommissionsTable.vue?vue&type=template&id=91ffbe10&scoped=true"
import script from "./ActivityCommissionsTable.vue?vue&type=script&lang=js"
export * from "./ActivityCommissionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ffbe10",
  null
  
)

export default component.exports